import React from 'react'

import { Column, Layout, Row, Rows, Section } from '@/components/layout'
import { Link } from '@/components/common'

import styles from './policies.module.scss'

const pageId = 'policies'

export default function Policies() {
  return (
    <Layout.Content>

      <Section bgBlob>
        <Row>
          <Column center textCenter>
            <h3 style={{ marginBottom: '0' }}>Neat Policies</h3>
            <h1>Welcome to the Neat Policy Center</h1>
            <p>We hope you’re enjoying all that Neat has to offer. Please read through our policies here.</p>
            <div className="rows gap-16">
              <Rows gap={24}>
                <Link
                  className={styles.link}
                  iconProps={{ name: 'chevron-right', position: 'right' }}
                  messageId="pages.policies.terms"
                  size="large"
                  to="/terms-conditions"
                  variant="primary"
                />
                <Link
                  className={styles.link}
                  iconProps={{ name: 'chevron-right', position: 'right' }}
                  messageId="pages.policies.privacy"
                  size="large"
                  to="/policies/privacy"
                  variant="primary"
                />
                <Link
                  className={styles.link}
                  iconProps={{ name: 'chevron-right', position: 'right' }}
                  messageId="pages.policies.salesTax"
                  size="large"
                  to="/policies/sales-tax"
                  variant="primary"
                />
                <Link
                  className={styles.link}
                  iconProps={{ name: 'chevron-right', position: 'right' }}
                  messageId="pages.policies.email"
                  size="large"
                  to="/email-preferences"
                  variant="primary"
                />
              </Rows>
            </div>
          </Column>
        </Row>
      </Section>
      <Section />
    </Layout.Content>
  )
}

Policies.layoutProps = {
  pageId,
}
